import _objectWithoutProperties from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js";
var _excluded = ["middlewares", "useDirective"];
import vueCompat from '@tencent/vue-compat';
import { createDirective } from "../directives";
import { setMiddlewares } from "../middleware";
import { createReporter } from "../reporter";
var reporter;
export function useReporter() {
  return reporter;
}
var plugin = vueCompat.useWrap({
  install: function install(Vue, options) {
    var _options$middlewares = options.middlewares,
        middlewares = _options$middlewares === void 0 ? [] : _options$middlewares,
        _options$useDirective = options.useDirective,
        useDirective = _options$useDirective === void 0 ? true : _options$useDirective,
        params = _objectWithoutProperties(options, _excluded);

    if (!middlewares.length) {
      throw new Error('middlewares can not be empty');
    }

    reporter = createReporter(params, middlewares); // 初始化中间件，用于处理指令逻辑

    setMiddlewares(middlewares); // 用于异步加载上报sdk场景，先初始化指令

    if (useDirective) {
      createDirective(Vue);
    } // eslint-disable-next-line


    Vue.prototype.$report = reporter;
  }
});
export default plugin;